import { micrositesConstants } from '@constants/microsites';

const initialState = {
    data: {
        microsites: [],
        totalCount: 0,
    },
    count: 0,
    averageRating: 0,
    loading: true,
};

export function microsites(state = initialState, action) {
    switch (action.type) {
        case micrositesConstants.MICROSITES_REQUEST:
            return { ...state, loading: true };
        case micrositesConstants.MICROSITES_SUCCESS:
            return { ...state, loading: false, data: action.microsites };
        case micrositesConstants.MICROSITES_ERROR:
            return { ...state, loading: false };
        case micrositesConstants.LOCATION_REVIEWS_SUCCESS:
            return {
                ...state,
                loading: false,
                count: action.payload.count,
                averageRating: action.payload.averageRating,
            };
        default:
            return state;
    }
}
